import { createFileRoute } from '@tanstack/react-router'
import Component from './-components/component'

export const Route = createFileRoute('/manager/_layout/dashboard/')({
  component: Component
})